// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_3dlak","avatar":"index_avatar_2ZxOW"};